import React from 'react';
import {FaTimes} from 'react-icons/fa';

export default function Modal (props) {
    return (<div id="add-wishlist" className={`modal ${props.visible ? 'modal-open': ''}`}>
        <div className="modal-window">
            <div className={`modal-inner ${props.innerClassName}`}>
                <a href="#modalClose" className="modal-close" onClick={props.onClose}><FaTimes /></a>
                {props.children}
            </div>
        </div>
    </div>);
}
